import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetAdminUsers, callGetUsers } from 'helpers/api_helper';

export const getUsers = createAsyncThunk('users/callGetUsers', async () => {
  try {
    const response = await callGetUsers();
    return response;
  } catch (error) {
    return error;
  }
});

export const getAdminUsers = createAsyncThunk('users/callGetAdminUsers', async () => {
  try {
    const response: any = await callGetAdminUsers();
    return Array.isArray(response?.data) ? response.data : [];
  } catch (error) {
    return error;
  }
});
